var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "top",
            "label-width": "auto",
          },
        },
        [
          _vm.canSelectUser
            ? _c(
                "el-form-item",
                { attrs: { label: "Owner", prop: "user_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: { filterable: "", disabled: _vm.isEditMode },
                      on: { input: _vm.onUserSelected },
                      model: {
                        value: _vm.form.user_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "user_id", $$v)
                        },
                        expression: "form.user_id",
                      },
                    },
                    _vm._l(_vm.users, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.full_name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Brand", prop: "brand_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-100",
                  attrs: { disabled: _vm.isEditMode },
                  on: { input: _vm.onBrandSelected },
                  model: {
                    value: _vm.form.brand_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "brand_id", $$v)
                    },
                    expression: "form.brand_id",
                  },
                },
                _vm._l(_vm.brands, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.title, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isImportMode
            ? _c(
                "el-form-item",
                { attrs: { label: "Email address", prop: "email_address_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: { disabled: _vm.isEditMode },
                      model: {
                        value: _vm.form.email_address_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email_address_id", $$v)
                        },
                        expression: "form.email_address_id",
                      },
                    },
                    _vm._l(_vm.emailAddresses, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.address,
                          disabled: _vm.hasNotOutgoingNumbers(item),
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Name", prop: "name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isNormalMode
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Contacts expire from this group in X days",
                    prop: "expiry_period",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { precision: 0, min: 1 },
                    model: {
                      value: _vm.form.expiry_period,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "expiry_period", $$v)
                      },
                      expression: "form.expiry_period",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isImportMode
            ? _c(
                "el-form-item",
                { attrs: { label: "Import Contacts", prop: "contacts_file" } },
                [
                  _vm.isFileSelected
                    ? _c("div", [
                        _c("em", [_vm._v(_vm._s(this.filename))]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "btn btn-link btn-link-red px-1",
                            on: { click: _vm.clearFile },
                          },
                          [_c("i", { staticClass: "fas fa-times-circle" })]
                        ),
                      ])
                    : _c("file-input", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ clickHandler }) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "btn btn-link btn-link-purple px-0",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return clickHandler.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-folder-open",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          316823155
                        ),
                        model: {
                          value: _vm.form.file,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "file", $$v)
                          },
                          expression: "form.file",
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-form-item", [
            _c(
              "button",
              {
                staticClass: "btn btn-purple",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.store.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Save")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }